import { defineStore } from 'pinia';
import type { ServerInfoResponse } from '@/shared/DTO/SRV/ServerInfoResponse';
import { ref } from 'vue';

export const useServerStore = defineStore('server', () => {
    const Server = ref<ServerInfoResponse | null>(null);

    function setServer(server: ServerInfoResponse) {
        Server.value = server;
    }

    function reset() {
        Server.value = null;
    }

    return {
        Server,
        setServer,
        reset,
    };
}, {
    persist: true
});

export type ServerStore = ReturnType<typeof useServerStore>;
